export default "/images/vendor/flag-icons/flags/4x3/py.svg?ba007e233124b637c2c2e06d45b70c38";